import { defineStore } from "pinia";

interface Navigation {
    slideout: {
        visible: boolean;
    };
}

export const useAppStore = defineStore("app", {
    state: () => {
        return {
            navigation: {
                slideout: {
                    visible: false,
                },
            },
        } as { navigation: Navigation };
    },
});
